namespace SorAraBul.Administration {

    @Serenity.Decorators.registerEditor()
    export class PurchasePackageFeaturesEditor extends Serenity.Extensions.GridEditorBase<PurchasePackageFeaturesRow> {
        protected getColumnsKey() { return PurchasePackageFeaturesColumns.columnsKey; }
        protected getDialogType() { return PurchasePackageFeaturesEditorDialog; }
        protected getLocalTextPrefix() { return PurchasePackageFeaturesRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getAddButtonCaption() {
            return "Özellik Ekle";
        }

        protected validateEntity(row: PurchasePackageFeaturesRow, id: number) {
            row.FeatureText = Q.trimToNull(row.FeatureText);

            if (!row.FeatureText) {
                Q.notifyError("Özellik metni zorunludur.");
                return false;
            }

            row.SortOrder = row.SortOrder || 0;
            row.IsActive = row.IsActive == null ? 1 : row.IsActive;

            return true;
        }
    }
}
